import { render, staticRenderFns } from "./UpdateUsers.vue?vue&type=template&id=5a517c96&scoped=true&"
import script from "./UpdateUsers.vue?vue&type=script&lang=js&"
export * from "./UpdateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a517c96",
  null
  
)

export default component.exports